import { render, staticRenderFns } from "./findChallenges.vue?vue&type=template&id=6542e1cc&scoped=true&"
import script from "./findChallenges.vue?vue&type=script&lang=js&"
export * from "./findChallenges.vue?vue&type=script&lang=js&"
import style0 from "./findChallenges.vue?vue&type=style&index=0&id=6542e1cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6542e1cc",
  null
  
)

export default component.exports